import { cn } from '@/shadcn-ui/utils';
import { getSortNameReadableFormat } from '../utils/sort-naming-util';
import ChevronDropdown from '@/icons/chevron-dropdown';

interface SortTriggerProps {
  disabled?: boolean;
  option?: string;
  classNameText?: string;
  chevronFill?: string;
}

export default function SortTrigger({
  disabled,
  option,
  classNameText,
  chevronFill = 'fill-flexcar-blue30',
}: SortTriggerProps) {
  const value = getSortNameReadableFormat(option);
  return (
    <div className="flex items-center justify-center gap-1 text-sm">
      Sort by
      <p
        className={cn(
          `body2-strong`,
          {
            'text-flexcar-neutral70': disabled,
            'text-flexcar-blue30': !disabled,
          },
          classNameText
        )}
      >
        {value}
      </p>
      <ChevronDropdown
        className={cn(
          {
            'fill-flexcar-neutral70': disabled,
            'fill-flexcar-blue30': !disabled,
          },
          chevronFill
        )}
      />
    </div>
  );
}
